import React, { useState } from 'react'
import ProfileSidebar from '../../../components/ProfileSidebar'
import PrivateRoute from '../../../components/PrivateRoute'

import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Divider,
  useMediaQuery,
  useTheme,
  LinearProgress,
  Alert,
} from '@mui/material'

import { useSelector, useDispatch } from 'react-redux'
import { deleteProfile, editProfile } from '../../../actions/userActions'

const Settings = () => {
  const [formData, setFormData] = useState({
    name: '',
    newPassword: '',
    currentPassword: ''
  })
  const theme = useTheme()
  const matches = useMediaQuery(theme.breakpoints.up('md'))
  const { loading, error } = useSelector(state => state.userState)
  const dispatch = useDispatch()

  const editProfileForm = e => {
    e.preventDefault()
    dispatch(editProfile(formData.name, formData.newPassword, formData.currentPassword))
    setFormData({ name: '', newPassword: '', currentPassword: '' })
  }

  const changeField = e => setFormData({ ...formData, [e.target.name]: e.target.value })

  return (
    <PrivateRoute>
      <Box sx={{ display: 'flex' }}>
        <ProfileSidebar page={3} />
        <Card sx={{ width: matches ? 700 : 1200, mt: 5, height: 'fit-content', mx: matches ? 'auto' : 0, p: 1 }}>
          {loading && <LinearProgress />}
          <CardContent>
            <Typography gutterBottom variant='h6'>Edit Account</Typography>
            <Typography color='textSecondary' gutterBottom>Leave blank to keep the same</Typography>
            {error && <Alert severity='error'>{error}</Alert>}
            <form onSubmit={editProfileForm}>
              <TextField
                label='Name'
                fullWidth
                sx={{ my: 2 }}
                name='name'
                type='text'
                onChange={changeField}
                value={formData.name}
              />
              <TextField
                label='New password'
                fullWidth
                type='password'
                sx={{ my: 2 }}
                name='newPassword'
                onChange={changeField}
                value={formData.newPassword}
              />
              <TextField
                label='Current password'
                fullWidth
                type='password'
                sx={{ my: 2 }}
                name='currentPassword'
                onChange={changeField}
                value={formData.currentPassword}
              />
              <Button variant='contained' type='submit' fullWidth>Submit</Button>
            </form>
          </CardContent>
        </Card>
      </Box>
    </PrivateRoute>
  )
}

export default Settings